import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../../lib/i18n";
import { useBrands } from "../../lib/queries";

export default function BrandMarquee() {
  const { data: brands = [] } = useBrands();
  const { t } = useLang();

  return (
    <section id="marquee" data-testid="brands-section" className="py-24 border-y border-white/5 bg-[#0A0A11] relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-10 flex items-end justify-between">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <span className="w-8 h-px bg-[#A855F7]" />
            <span className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] uppercase">
              Trust ·
            </span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl uppercase tracking-tighter text-white">
            {t("brands_title")}
          </h2>
        </div>
        <span className="hidden md:block font-mono-ui text-[10px] tracking-widest text-white/40 uppercase">
          {brands.length.toString().padStart(2, "0")} · Clients
        </span>
      </div>

      {/* Editorial huge stroke marquee */}
      <Marquee gradient={false} speed={40} pauseOnHover>
        <div className="flex items-center">
          {brands.concat(brands).map((b, i) => (
            <span
              key={`${b.id}-${i}`}
              data-testid={`brand-${b.id}`}
              className="stroke-text font-display uppercase tracking-tighter text-6xl md:text-8xl mx-10"
            >
              {b.name}
              <span className="text-[#A855F7] ml-6">✦</span>
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
